import { render, staticRenderFns } from "./MyStores.vue?vue&type=template&id=17a00f1f&scoped=true"
import script from "./MyStores.vue?vue&type=script&lang=js"
export * from "./MyStores.vue?vue&type=script&lang=js"
import style0 from "./MyStores.vue?vue&type=style&index=0&id=17a00f1f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a00f1f",
  null
  
)

export default component.exports